/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyDocumentApprovalDocumentViewModel } from "../types/AssociatedCompanyDocumentApprovalDocumentViewModel.ts";
import { associatedCompanyDocumentApprovalAttachmentViewModelSchema } from "./associatedCompanyDocumentApprovalAttachmentViewModelSchema.ts";

export const associatedCompanyDocumentApprovalDocumentViewModelSchema =
  z.object({
    associatedCompanyDocumentId: z.optional(
      z.number().int().describe("ID do documento de empresa associada (tipo)."),
    ),
    documentName: z
      .string()
      .describe("Nome do documento resolvido pelo idioma atual.")
      .nullish(),
    isRequired: z.optional(
      z
        .boolean()
        .describe(
          "Indica se o documento é obrigatório para o status geral da documentação.",
        ),
    ),
    canBeReadByOcr: z.optional(
      z
        .boolean()
        .describe(
          "Indica se o tipo é passível de leitura por OCR (regra herdada da view legada).",
        ),
    ),
    attachments: z
      .array(
        z.lazy(
          () => associatedCompanyDocumentApprovalAttachmentViewModelSchema,
        ),
      )
      .describe(
        "Anexos enviados pelo aluno para o documento, do mais recente para o mais antigo.",
      )
      .nullish(),
  }) as unknown as ToZod<AssociatedCompanyDocumentApprovalDocumentViewModel>;
